import { NavBar } from "../navBar/NavBar";

import type { NavBarGroupProps } from "../navBar/NavBarGroup";

export interface WatchViewHeaderGroupProps extends NavBarGroupProps {}

export function WatchViewHeaderGroup({
  align,
  children,
  full,
}: WatchViewHeaderGroupProps) {
  return (
    <NavBar.Group align={align} full={full}>
      {children}
    </NavBar.Group>
  );
}
